module.exports = __webpack_public_path__ + "src/modules/home/training/images/1709.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1709.png
// module id = 792
// module chunks = 0